import * as React from 'react';
import { PureAbility } from '@casl/ability';
import { createContextualCan, useAbility as useCaslAbility } from '@casl/react';

import type { AppAbility } from '~/shared/auth/permissions';

// Create a default empty ability instance
const createDefaultAbility = () => new PureAbility([]) as AppAbility;

export const AbilityContext = React.createContext<AppAbility>(
  createDefaultAbility()
);

export const Can = createContextualCan(AbilityContext.Consumer);

type AbilityProviderProps = {
  ability: AppAbility;
  children: React.ReactNode;
};

export function AbilityProvider({ ability, children }: AbilityProviderProps) {
  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
}

export function useAbility() {
  return useCaslAbility(AbilityContext);
}
